import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AdminHelpListComponent } from './help-list.component';
import { HelpService } from './help.service';

@Component({
    selector: 'convfact-adminhelpdelete',
    templateUrl: './help-dialog-delete.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})

export class AdminHelpDialogDeleteComponent {
    uid: string = this.data.uid;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<AdminHelpListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public helpService: HelpService
    ) { }


    delete() {
        this.helpService.deleteHelp(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}